import App from './App';
import BlockDetail from './BlockDetail/BlockDetail';
import ElevatedBox from './ElevatedBox/ElevatedBox';
import Form from './Form/Form';
import HomePage from './HomePage/HomePage';
import ImgCheckbox from './ImgCheckbox/ImgCheckbox';
import LoadingPage from './LoadingPage/LoadingPage';
import LoginPage from './LoginPage/LoginPage';
import AboutUsPage from './AboutUsPage/AboutUsPage';
import MacBackground from './MacBackground/MacBackground';
import NotFoundPage from './NotFoundPage/NotFoundPage';
import RegisterPage from './RegisterPage/RegisterPage';
import ConfirmEmailPage from './ConfirmEmailPage/ConfirmEmailPage';
import SetNewPasswordPage from './SetNewPasswordPage/SetNewPasswordPage';
import Root from './Root';
import Timetable from './Timetable/Timetable';
import TimetablePage from './TimetablePage/TimetablePage';
import Toolbar from './Toolbar/Toolbar';
import AddBlockForm from './AddBlockForm/AddBlockForm';
import PersonalNumber from './PersonalNumber/PersonalNumber';

export {
  App,
  BlockDetail,
  ElevatedBox,
  Form,
  HomePage,
  ImgCheckbox,
  LoadingPage,
  LoginPage,
  AboutUsPage,
  MacBackground,
  NotFoundPage,
  RegisterPage,
  ConfirmEmailPage,
  Root,
  Timetable,
  TimetablePage,
  AddBlockForm,
  PersonalNumber,
  Toolbar,
  SetNewPasswordPage
};



// WEBPACK FOOTER //
// ./src/components/index.js